;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();function isPBSUrl(url: string) {
  try {
    const urlObj = new URL(url)
    const isPBSUrl = urlObj.hostname === 'pbs.org' || urlObj.hostname === 'www.pbs.org';
    return isPBSUrl
  } catch (_error) {
    return false
  }
}

export default isPBSUrl
